import React from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

import styles, { logoSize } from './style';
import Box from '../../../../../components/atomic/Box';
import { truncate } from '../../../../../utils/strings';
import Link from '../../../../../components/atomic/Link';
import BaseHeader from '../../../../../components/Header';
import Logo from '../../../../../assets/icons/BoligmappaLogo';
import Typography from '../../../../../components/atomic/Typography';
import { getPropertyAddress } from '../../../../../utils/properties';
import ContentLoader from '../../../../../components/loaders/ContentLoader';
import IconButton from '../../../../../components/atomic/IconButton';
import Badge from '../../../../../components/atomic/Badge';
import NotificationIcon from '../../../../../assets/icons/Notification';
import { sGetUnseenNotifications } from '../../../../../store/reducers/notifications';

const Header = ({
  error,
  classes,
  children,
  fetching,
  property,
  className,
  notificationsLink,
  unseenNotifications,
  ...props
}) => (
  <BaseHeader
    containerProps={{ disableGutters: true }}
    className={clsx(className, classes.header)}
    {...props}
  >
    {fetching ? (
      <div className={classes.content}>
        <ContentLoader
          width={logoSize}
          height={logoSize}
          variant="circle"
          className={classes.logoLoader}
        />
        <Box width="100%" paddingRight={`${logoSize}px`}>
          <ContentLoader width={150} height={20} />
        </Box>
      </div>
    ) : (
      <div className={classes.content}>
        <Link to="/properties" underline={false}>
          <Logo className={classes.logo} />
        </Link>

        <Link to="/properties" underline={false}>
          <Box paddingRight={`${logoSize}px`} width="100%">
            <Typography noMargins variant="h3" fontWeight={400}>
              <small>
                {error
                  ? 'Boligmappa'
                  : truncate(getPropertyAddress(property), { length: 20 })}
              </small>
            </Typography>
          </Box>
        </Link>

        <div className={classes.grow} />
        <Link inheritColor to={notificationsLink}>
          <IconButton color="primary">
            <Badge
              classes={{ badge: classes.badge }}
              badgeContent={unseenNotifications.length}
            >
              <NotificationIcon className={classes.notificationIcon} />
            </Badge>
          </IconButton>
        </Link>
      </div>
    )}
    {children}
  </BaseHeader>
);

const mapStateToProps = (state) => ({
  unseenNotifications: sGetUnseenNotifications(state),
});

export default connect(mapStateToProps)(withStyles(styles)(Header));
